module.exports = __webpack_public_path__ + "static/media/REW_Results1.26658afb.jpg";